import { styled } from '@material-ui/core/styles';
import { Button, CircularProgress } from '@material-ui/core';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import {FileUploadLogic} from './fileUpload.module';

const FileUpload = (props) => {
  const { isUploading, handleFileUpload } = FileUploadLogic(props);

  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });

  const handleFileChange = async (event) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;
    const file = files[0];    
    await handleFileUpload(file);    
    event.target.value = '';
  };

  return (
    <Button
      component="label"
      role={undefined}
      variant="contained"
      tabIndex={-1}
      startIcon={isUploading ? <CircularProgress size={20} /> : <CloudUploadIcon />}
      disabled={isUploading}
      {...props} // Pasa cualquier otra prop al Button (como sx, color, etc.)
    >
      {isUploading ? 'Uploading...' : (props.buttonText || 'Upload file')}
      <VisuallyHiddenInput
        type="file"
        onChange={handleFileChange}
        multiple={false}
      />
    </Button>
  );
};

export default FileUpload;